import { render, staticRenderFns } from "./imageCall.pug?vue&type=template&id=4ab23a12&scoped=true&lang=pug&"
import script from "./imageCall.js?vue&type=script&lang=js&"
export * from "./imageCall.js?vue&type=script&lang=js&"
import style0 from "./imageCall.scss?vue&type=style&index=0&id=4ab23a12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab23a12",
  null
  
)

export default component.exports